import {ActionEnum} from '../action.enum';
import {ChecklistTemplateEntry} from '../../models/checklist-template-entry/checklist-template-entry.model';
import {ChecklistEntryType} from '../../enums/checklist-entry/checklist-entry-type.enum';
import { DocumentModel } from '../../models/document/document.model';

export namespace ChecklistTemplateEntryManagerAction {

  export class Create {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_CREATE;

    constructor(
      public insertBeforeEntryId: string,
      public insertAfterEntryId: string,
      public type?: ChecklistEntryType,
      public tableType?: ChecklistEntryType
    ) {
    }
  }

  export class CreatePageBreak {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_CREATE_PAGE_BREAK;

    constructor(public insertBeforeEntryId: string, public insertAfterEntryId: string) {
    }
  }

  export class Edit {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_EDIT;

    constructor(public id: string) {
    }
  }

  export class UpdateEntry {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_UPDATE_ENTRY_STATE;

    constructor(public checklistTemplateEntry: Partial<ChecklistTemplateEntry>) {
    }
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_SAVE;
  }

  export class Delete {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_DELETE;

    constructor(public id?: string, public wholeBlock: boolean = false) {
    }
  }

  export class Group {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_GROUP;

    constructor(public id?: string) {}
  }

  export class Ungroup {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_UNGROUP;

    constructor(public id?: string) {}
  }

  export class ShiftLeft {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_SHIFT_LEFT;

    constructor() {}
  }

  export class ShiftRight {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_SHIFT_RIGHT;

    constructor() {}
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_RESET_STATE;
  }

  export class AddImage {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_ADD_IMAGES;

    constructor(public image: File, public optionIndex: number) {
    }
  }

  export class AddFiles {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_ADD_FILES;

    constructor(public files: File[], public optionIndex: number) {
    }
  }

  export class RemoveFile {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_DELETE_FILE;

    constructor(public file: DocumentModel, public optionIndex: number, public fileIndex: number) {
    }
  }

  export class SetRemoveImages {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_SET_REMOVE_IMAGES;

    constructor(public optionIndex: number) {
    }
  }

  export class DeleteImage {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_MANAGER_DELETE_IMAGES;

    constructor(public optionIndex: number) {
    }
  }

  export class PasteDuplicateEntries{
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_DUPLICATE_PASTE;

    constructor(
      public insertBeforeEntryId: string,
      public insertAfterEntryId: string,
      public entryId?: string,
      public duplicateBlock?: boolean
    ) {}
  }

  export class PasteDuplicateAllEntries{
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_DUPLICATE_PASTE_ALL;

    constructor(
      public insertBeforeEntryId: string,
      public insertAfterEntryId: string,
      public checklistTemplateVersionId: string
    ) {}
  }
}
